import { httpRequest } from "@services/http";
import type { LaunchListQuery, LaunchListResponse } from "../models/launchList";
import { legacyDashboardUrl } from "./legacyDashboardUrl";

export class CommandGetLaunchList {
    async run(query: LaunchListQuery): Promise<LaunchListResponse> {
        const url = legacyDashboardUrl("launch-list/");
        const { affiliate, attribute, created_by, page, page_size, ...rest } = query;
        Object.entries(rest).forEach(([key, value]) => url.searchParams.set(key, value));
        url.searchParams.set("affiliate", affiliate.join(","));
        url.searchParams.set("attribute", attribute.join(","));
        url.searchParams.set("created_by", created_by.join(","));
        url.searchParams.set("page", String(page));
        url.searchParams.set("page_size", String(page_size));
        return await httpRequest<LaunchListResponse>(url.toString());
    }
}
